// services/personal.service.ts
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Bank } from '../store/bank/bank.state'
import { eps } from './url.service'

@Injectable({ providedIn: 'root' })
export class BankService {
  private apiUrl = eps.bankDetail.bankDetailApi

  constructor(private http: HttpClient) {}

  getBanks(
    params: string | null,
    page: number | null | undefined,
    limit: number | null | undefined
  ): Observable<{ bankdetails: Bank[] }> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<{ bankdetails: Bank[] }>(url)
  }

  createBank(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, payload)
  }

  updateBank(id: string, payload: any): Observable<Bank> {
    return this.http.put<Bank>(`${this.apiUrl}/${id}`, payload)
  }

  deleteBank(bankId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${bankId}`, {})
  }

  setDefaultPolicy(id: string): Observable<{ message: string; data: any }> {
    return this.http.patch<{ message: string; data: any }>(`${this.apiUrl}/${id}/default`, {})
  }
}
